<template>
    <div class="m-promotionProductsTable">
        <div class="product-set__head">
            <div class="product-set__info">
                <h2 class="typo">
                    {{ title }} ({{
                        +pagination.totalRecords
                            | plurals('produkt', 'produkty', 'produktów')
                    }})
                </h2>
                <template v-if="isBonded">
                    <p v-if="isSetTrigger(productSet)">
                        Lista produktów, których zakup wyzwala promocję.
                        <strong>({{ +productSet.required_weight }} szt.)</strong>
                    </p>
                    <p v-else>
                        Produkty, które będą rabatowane
                        <strong>({{ +productSet.required_weight }} szt.)</strong>
                    </p>
                </template>
                <p v-else-if="promotion.type !== 'Promo::Mix1'">
                    Zestaw #{{ index + 1 }} - Liczba punktów wywołujących
                    promocję:
                    <strong>{{ +productSet.required_weight }}</strong>
                </p>
                <p v-else-if="promotion.type === 'Promo::Mix1'">
                    Konsument może wybrać
                    <strong>{{
                        +productSet.required_weight
                            | plurals(
                                'dowolną sztukę',
                                'dowolne sztuki',
                                'dowolnych sztuk'
                            )
                    }}</strong>
                    z poniższej puli
                </p>
                <p v-else>
                    Sumaryczna liczba punktów wybranych produktów musi
                    przekraczać
                    <strong>{{ +productSet.required_weight }}</strong>.
                    <br />Dopiero wtedy zostanie przyznany Zwrot Kosztów.
                </p>
            </div>

            <!-- Set price -->
            <div class="form-group" v-if="isBonded">
                <label class="form-label">{{ +productSet.required_weight }} szt.</label>
                <template v-if="isSetTrigger(productSet)">
                    <span class="u-price">Cena regularna</span>
                </template>
                <template v-else-if="promotion.type === 'Promo::BondedQuota'">
                    <span class="u-price">
                        {{ `Rabat brutto do zestawu: -` }}
                        {{
                            (+productSet.required_weight *
                                productSet.discount_amount)
                                | currency
                        }}
                    </span>
                </template>
                <template
                    v-else-if="promotion.type === 'Promo::BondedPercentage'"
                >
                    <span class="u-price">
                        {{ `Rabat brutto: -${productSet.discount_percentage}%` }}
                    </span>
                </template>
                <template v-else>
                    <span class="u-price">{{
                        +productSet.required_weight === 1
                            ? `Cena max.: ${setPrice} / szt.`
                            : `Cena zestawu: ${setPrice}`
                    }}</span>
                </template>
            </div>
            <div class="form-group" v-else>
                <label class="form-label">Maksymalna cena zestawu</label>
                <span class="u-price">{{ setPrice }}</span>
            </div>
        </div>
        <div class="product-set__list">
            <div class="c-table">
                <div class="c-thead" v-sticky-elem="{ background: 'var(--color-white)', shadow: true }">
                    <div class="c-tw w-names">
                        <div class="c-td c-promos-image"></div>
                        <div class="c-td">Produkt</div>
                    </div>
                    <div class="c-tw w-numbers">
                        <div
                            v-if="
                                !isBonded ||
                                    (isBonded && !isSetTrigger(productSet))
                            "
                            class="c-td c-cashback"
                        >
                            Zwrot netto
                        </div>
                        <!-- Cena hurtowa (max. marża) ECD-->
                        <div v-if="!isBonded" class="c-td">
                            Max cena hurt. ECD
                            <div class="d-flex align-items-center">
                                (marża %)
                                <a-icon
                                    icon="Info"
                                    width="1rem"
                                    height="1rem"
                                    class="text-dark ml-1"
                                    v-tooltip="wholesalePriceMarginTooltip('ECD')"
                                ></a-icon>
                            </div>
                        </div>
                        <!-- Cena hurtowa (max. marża) ECC-->
                        <div v-if="!isBonded" class="c-td">
                            Max cena hurt. ECC
                            <div class="d-flex align-items-center">
                                (marża %)
                                <a-icon
                                    icon="Info"
                                    width="1rem"
                                    height="1rem"
                                    class="text-dark ml-1"
                                    v-tooltip="wholesalePriceMarginTooltip('ECC')"
                                ></a-icon>
                            </div>
                        </div>
                        <!-- Cena hurtowa (max. marża) DZ-->
                        <div v-if="!isBonded" class="c-td">
                            Max cena hurt. DZ
                            <div class="d-flex align-items-center">
                                (marża %)
                                <a-icon
                                    icon="Info"
                                    width="1rem"
                                    height="1rem"
                                    class="text-dark ml-1"
                                    v-tooltip="wholesalePriceMarginTooltip('DZ')"
                                ></a-icon>
                            </div>
                        </div>
                    </div>
                </div>
                <page-preloader
                    mode="wrapper"
                    :is-loading="isLoading"
                >
                    <div class="c-tbody">
                        <product-tree
                            component-name="PromoProduct"
                            :products="productSet.product_set_dict_products"
                            :promotion="promotion"
                            :product-set="productSet"
                            :root-margin="-305"
                        />
                    </div>
                </page-preloader>
            </div>
            <div class="c-tfooter">
                <results-dropdown
                    v-if="pagination"
                    :per-page="+pagination.perPage"
                    :options="[10, 20, 50, 100]"
                    :on-change="changeResultsPerPage"
                />
                <the-pagination
                    :pagination="pagination"
                    :is-loading="getPromoProductsStatus === 'loading'"
                    @change="changePage"
                />
            </div>
        </div>
    </div>
</template>

<script>
import promoBonded from '@/mixins/promoBonded'

export default {
    mixins: [promoBonded],

    props: {
        promotion: {
            type: Object,
            default: () => {}
        },
        productSet: {
            type: Object,
            default: () => {}
        },
        index: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            isLoading: false
        }
    },

    computed: {
        pagination() {
            return this.productSet.pagination
        },

        title() {
            if (!this.isBonded) {
                return 'Zestaw produktów promocyjnych'
            }

            // If the promotion is bonded, we need to check if it's a trigger set
            if (this.isSetTrigger(this.productSet)) {
                return 'Lista produktów wywołujących promocję'
            }
            return 'Lista produktów rabatowanych'
        },

        setPrice() {
            return this.$options.filters.currency(this.productSet.price)
        },

        perPage() {
            return this.$store.getters.getPromoProductsPerPage
        },

        getPromoProductsStatus() {
            return this.$store.getters.getPromoProductsStatus
        }
    },
    methods: {
        scrollToSetTop() {
            const top = this.$el
            const headerHeight = document.querySelector('.site-header')
                .clientHeight
            this.$scrollTo(top, 100, {
                offset: -headerHeight - 16
            })
        },

        changeResultsPerPage(val) {
            this.$store.commit('SET_PROMO_PRODUCTS_PER_PAGE', val)

            this.loadProducts({
                page: 1
            })
            this.scrollToSetTop()
        },

        changePage(page) {
            this.loadProducts({
                page
            })
            this.scrollToSetTop()
        },

        async loadProducts(params) {
            if (this.isLoading) {
                return
            }

            this.isLoading = true

            try {
                await this.$store.dispatch('loadPromoProducts', {
                    ...params,
                    includes: 'dict_product,dict_product.image',
                    productSets: [this.productSet],
                    per: this.perPage
                })
            } finally {
                this.isLoading = false
            }
        },

        wholesalePriceMarginTooltip(code) {
            return this.$store.getters.getWholesalePriceMarginTooltip(code)
        }
    }
}
</script>
